import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_qrcode,
  add_qrcode,
//   update_qrcode,
  delete_qrcode,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";
const initialState = {
  qrcodes: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    data:"" ,   
name:"" ,   
type:"custom"    
  },
};

// Async Thunks for API Calls
export const fetchqrcode = createAsyncThunk(
  "qrcode/fetchqrcode",
  async (
    { page, page_size,type, school_id, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_qrcode(
        page,
        page_size,
        type,
        school_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createqrcode = createAsyncThunk(
  "qrcode/createqrcode",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_qrcode(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// export const updateqrcode = createAsyncThunk(
//   "qrcode/updateqrcode",
//   async ({ data, token, signal }, { rejectWithValue }) => {
//     try {
//       const response = await update_qrcode(data, token, signal);
//       if (response.status) {
//         return response.response;
//       } else {
//         return rejectWithValue(response.response.message);
//       }
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

export const deleteqrcode = createAsyncThunk(
  "qrcode/deleteqrcode",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_qrcode({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const qrcodeSlice = createSlice({
  name: "qrcodes",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
        const { name, value } = action.payload;
        state.filterData[name] = value;
      },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const {
        id,
        category ,   
description ,   
image
      } = action.payload;
      state.formData = {
        id,
        category ,   
        description ,   
        image
      };
    },
    resetFormData(state) {
      state.formData = {
        data:"" ,   
        name:"" ,   
        type:"custom"   
      };
    },
    setqrcode(state, action) {
      state.qrcodes = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
   
      .addCase(fetchqrcode.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchqrcode.fulfilled, (state, action) => {
        state.loading = false;
        state.qrcodes = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchqrcode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.qrcodes = [];

      })

      // Add Class
      .addCase(createqrcode.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createqrcode.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createqrcode.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update Class
    //   .addCase(updateqrcode.pending, (state) => {
    //     state.addLoading = true;
    //   })
    //   .addCase(updateqrcode.fulfilled, (state, action) => {
    //     state.addLoading = false;
    //     state.IsEditing = false;

    //     toast.success(action?.payload?.message || "Something went wrong!");
    //   })
    //   .addCase(updateqrcode.rejected, (state, action) => {
    //     state.addLoading = false;
    //     state.error = action.payload;
    //     state.IsEditing = false;
    //     toast.info(action?.payload?.message || "Something went wrong!");
    //   })
      // Delete Class
      .addCase(deleteqrcode.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteqrcode.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteqrcode.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setqrcode,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  updateFilterData,

} = qrcodeSlice.actions;
export default qrcodeSlice.reducer;
